// @flow
import React from 'react';
import { Box } from '@locus-taxy/neo-ui';

type Props = {
    url: string,
    isOnline?: boolean,
    profileImageSize?: number,
    onlineIconSize?: number
};

const DEFAULT_PROFILE_WIDTH = 40;
const DEFAULT_PROFILE_HEIGHT = 40;

const DEFAULT_ONLINE_ICON_WIDTH = 10;
const DEFAULT_ONLINE_ICON_HEIGHT = 10;

const UserProfileImage = ({
    url,
    isOnline,
    profileImageSize,
    onlineIconSize
}: Props): React$Element<any> => {
    const profileImageStyles = {
        width: `${profileImageSize ?? DEFAULT_PROFILE_WIDTH}px`,
        height: `${profileImageSize ?? DEFAULT_PROFILE_HEIGHT}px`,
        borderRadius: '50%'
    };

    const onlineIconStyles = {
        width: `${onlineIconSize ?? DEFAULT_ONLINE_ICON_WIDTH}px`,
        height: `${onlineIconSize ?? DEFAULT_ONLINE_ICON_HEIGHT}px`,
        borderRadius: '50%'
    };

    const statusColor = isOnline ? 'green' : 'grey';
    return (
        <div style={{ position: 'relative' }}>
            <img
                style={profileImageStyles}
                src={url || 'img/user-photo-placeholder.svg'}
                alt="user image"
            />
            <Box
                padding="2px"
                sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'white',
                    borderRadius: '50%'
                }}
            >
                <Box
                    backgroundColor={`${statusColor}.500`}
                    sx={onlineIconStyles}
                />
            </Box>
        </div>
    );
};

export default UserProfileImage;
